import { Controller } from "@hotwired/stimulus"
import { showTurnOnWarning } from "../lib/turn_on_warning"

// A switch that warns before it turns ON (#20129, owner-approved mockup
// 2026-10-30): the Paid Call Features transcription switches. The warning —
// the agent's own price and the recording-consent note — comes from the server
// (Voice::TurnOnWarning) as JSON { title, paragraphs: [{ label, text }],
// confirm_label, cancel_label }.
// "Keep Off" (or a dialog that failed to open) puts the switch back OFF; "Turn
// On" leaves it on for the card's own Save. Turning it off never asks. The
// mirror of switch_off_confirm_controller.js, but it never submits the form.
//
//   %input{ type: 'checkbox', data: { controller: 'switch-on-warning',
//     action: 'change->switch-on-warning#change', 'switch-on-warning-warning-value': warning.to_json } }
export default class extends Controller {
  static values = { warning: Object }

  #prompting = false

  change () {
    if (!this.element.checked || this.#prompting || !this.warningValue.title) return

    this.#prompting = true
    showTurnOnWarning(this.warningValue)
      .then(
        (accepted) => {
          if (!accepted && this.element.isConnected) this.#keepOff()
        },
        (error) => {
          // Fail CLOSED: a warning that never appeared is not consent.
          console.error("switch-on-warning: confirmation dialog failed", error)
          this.#keepOff()
        }
      )
      .finally(() => {
        this.#prompting = false
      })
  }

  #keepOff () {
    this.element.checked = false
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
